// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Information-module--wrapper--1YEVt","image":"Information-module--image--1P3kK","content":"Information-module--content--28jaJ","title":"Information-module--title--319rT"};